import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { AddressListModule } from 'src/components/address-list/address-list.module'
import { SelectSearchModule } from '../../../../components/select-search/select-search.module'
import { AddBuyersGroupComponent } from './add-buyers-group/add-buyers-group.component'
import { CreateFromSharedGroupComponent } from './create-from-shared-group/create-from-shared-group.component'
import { MergeGroupsComponent } from './merge-groups/merge-groups.component'
import { ShareBuyersGroupComponent } from './share-buyers-group/share-buyers-group.component'
import { BuyersGroupsItemComponent } from './buyers-groups-item/buyers-groups-item.component'
import { MatTabsModule } from '@angular/material/tabs'
import { BadBuyersComponent } from './bad-buyers/bad-buyers.component'
import { MatTooltipModule } from '@angular/material/tooltip'

@NgModule({
  declarations: [
    BuyersGroupsItemComponent,
    AddBuyersGroupComponent,
    CreateFromSharedGroupComponent,
    MergeGroupsComponent,
    ShareBuyersGroupComponent,
  ],
  exports: [
    BuyersGroupsItemComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AddressListModule,
    FlexLayoutModule,
    SelectSearchModule,
    MatCheckboxModule,
    MatChipsModule,
    MatExpansionModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    BadBuyersComponent,
    MatTooltipModule,
  ],
})
export class BuyersGroupsModule {}
